/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {safetyNetStartAttestation} from '../api'

export const useMutationSafetyNetStartAttestation = createReactQueryMutationHook('safetyNetStartAttestation', safetyNetStartAttestation)
